import { GridSortDirection, GridSortItem, GridSortModel } from "@mui/x-data-grid";
import { EQLSearch } from '@eco/client'
import { useCallback, useMemo } from "react";
import { TDataGridSortFilter, useDataGridFilterState } from "./useDataGridFilterState";

export const useDataGridFilter = (id: string, isUrlParamsState: boolean = true, defaultValue?: TDataGridSortFilter) => {

    const { filter, setFilter } = useDataGridFilterState(id, isUrlParamsState, defaultValue)

    const handleSortModelChange = useCallback((newModel: GridSortModel) => {
        setFilter((v: TDataGridSortFilter) => ({ ...v, sort: newModel.map((item) => ({ property: item.field, direction: item.sort })) }))
    }, []);

    const handlePageSizeChange = (value: number) => {
        setFilter('pageSize', value)
    };

    const handlePageChange = (value: number) => {
        setFilter('page', value)
    };

    const sortModel = useMemo((): GridSortModel | undefined => {
        if (typeof filter.sort === 'string') {
            return [{ field: filter.sort, sort: 'asc' }]
        }

        return (filter.sort as EQLSearch['sort'])?.map<GridSortItem>((item) => ({
            field: item.property,
            sort: item.direction as GridSortDirection
        }))
    }, [filter])

    const rowPerPage = useMemo(() => ([5, 10, 20, 50, 100]), [])

    return {
        filter: {
            ...filter,
            pageSize: parseInt(filter?.pageSize?.toString() || '20'),
            page: parseInt(filter?.page?.toString() || '0'),
        },
        sortModel,
        rowPerPage,
        handleSortModelChange,
        handlePageSizeChange,
        handlePageChange
    }
}
